var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"section with-min-height"},[_c('div',{staticClass:"container is-fullwidth has-text-centered"},[_c('p',[_vm._v("Please wait while we retrieve your quote…")])])])
}]

export { render, staticRenderFns }